import React from "react"
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react"
import { DatePicker, Flex, Input, message, Select, Typography } from "antd"
import dayjs from "dayjs"
import { useDispatch, useSelector } from "react-redux"
import customParseFormat from "dayjs/plugin/customParseFormat"
import { useState } from "react"
import {
  addAbonement,
  getAbonementsClient,
  commentsAction,
} from "src/store/Slices/ClientsSlice"
import { openNotification } from "src/components/helpers/notification"
import { useEffect } from "react"
import { getClientsList } from "src/store/Slices/ClientsSlice"

const FilterModal = ({
  commentModal,
  setCommentModal,
  setFilterInfo,
  addEditPayload,
  setAddEditPayload,
  additionalFilters,
  setAdditionalFilters,
}) => {
  const dateFormatList = ["DD.MM.YYYY"]
  // HELPERS
  const dispatch = useDispatch()
  dayjs.extend(customParseFormat)

  useEffect(() => {
    setFilterInfo({ mnemo: "", value: null })
  }, [commentModal])

  const onClickSetFilter = () => {
    if (
      commentModal.twoField &&
      (fromDate === undefined || toDate === undefined)
    ) {
      openNotification({
        type: "error",
        message: "Введите дату полностью",
      })
    } else if (!commentModal.twoField && fromDate === undefined) {
      openNotification({
        type: "error",
        message: "Введите дату",
      })
    } else if (commentModal.type === "end" && !commentModal.twoField) {
      setAddEditPayload({
        ...addEditPayload,
        "AbonementDateEnd.From": dayjs(fromDate).format("YYYY-MM-DD"),
        "AbonementDateEnd.To": null,
        "AbonementDateStart.From": null,
        "AbonementDateStart.To": null,
      })
      setAdditionalFilters({
        "AbonementDateEnd.From": dayjs(fromDate).format("YYYY-MM-DD"),
        "AbonementDateEnd.To": null,
        "AbonementDateStart.From": null,
        "AbonementDateStart.To": null,
      })
      dispatch(
        getClientsList({
          ...addEditPayload,
          "AbonementDateEnd.From": dayjs(fromDate).format("YYYY-MM-DD"),
          "AbonementDateEnd.To": null,
          "AbonementDateStart.From": null,
          "AbonementDateStart.To": null,
        })
      ).then(() => {
        // setFilterInfo({mnemo: '', value: null})
        setCommentModal({ open: false, type: "", twoField: false })
      })
    } else if (commentModal.type === "end" && commentModal.twoField) {
      setAddEditPayload({
        ...addEditPayload,
        "AbonementDateEnd.From": dayjs(fromDate).format("YYYY-MM-DD"),
        "AbonementDateEnd.To": dayjs(toDate).format("YYYY-MM-DD"),
        "AbonementDateStart.From": null,
        "AbonementDateStart.To": null,
      })
      setAdditionalFilters({
        "AbonementDateEnd.From": dayjs(fromDate).format("YYYY-MM-DD"),
        "AbonementDateEnd.To": dayjs(toDate).format("YYYY-MM-DD"),
        "AbonementDateStart.From": null,
        "AbonementDateStart.To": null,
      })
      dispatch(
        getClientsList({
          ...addEditPayload,
          "AbonementDateEnd.From": dayjs(fromDate).format("YYYY-MM-DD"),
          "AbonementDateEnd.To": dayjs(toDate).format("YYYY-MM-DD"),
          "AbonementDateStart.From": null,
          "AbonementDateStart.To": null,
        })
      ).then(() => {
        // setFilterInfo({mnemo: '', value: null})
        setCommentModal({ open: false, type: "", twoField: false })
      })
    } else if (commentModal.type === "start" && !commentModal.twoField) {
      setAddEditPayload({
        ...addEditPayload,
        "AbonementDateEnd.From": null,
        "AbonementDateEnd.To": null,
        "AbonementDateStart.From": dayjs(fromDate).format("YYYY-MM-DD"),
        "AbonementDateStart.To": null,
      })
      setAdditionalFilters({
        "AbonementDateEnd.From": null,
        "AbonementDateEnd.To": null,
        "AbonementDateStart.From": dayjs(fromDate).format("YYYY-MM-DD"),
        "AbonementDateStart.To": null,
      })
      dispatch(
        getClientsList({
          ...addEditPayload,
          "AbonementDateEnd.From": null,
          "AbonementDateEnd.To": null,
          "AbonementDateStart.From": dayjs(fromDate).format("YYYY-MM-DD"),
          "AbonementDateStart.To": null,
        })
      ).then(() => {
        // setFilterInfo({mnemo: '', value: null})
        setCommentModal({ open: false, type: "", twoField: false })
      })
    } else if (commentModal.type === "start" && commentModal.twoField) {
      setAddEditPayload({
        ...addEditPayload,
        "AbonementDateEnd.From": null,
        "AbonementDateEnd.To": null,
        "AbonementDateStart.From": dayjs(fromDate).format("YYYY-MM-DD"),
        "AbonementDateStart.To": dayjs(toDate).format("YYYY-MM-DD"),
      })
      setAdditionalFilters({
        "AbonementDateEnd.From": null,
        "AbonementDateEnd.To": null,
        "AbonementDateStart.From": dayjs(fromDate).format("YYYY-MM-DD"),
        "AbonementDateStart.To": dayjs(toDate).format("YYYY-MM-DD"),
      })
      dispatch(
        getClientsList({
          ...addEditPayload,
          "AbonementDateEnd.From": null,
          "AbonementDateEnd.To": null,
          "AbonementDateStart.From": dayjs(fromDate).format("YYYY-MM-DD"),
          "AbonementDateStart.To": dayjs(toDate).format("YYYY-MM-DD"),
        })
      ).then(() => {
        setCommentModal({ open: false, type: "", twoField: false })
      })
    }
  }

  // STATE
  const [fromDate, setFromDate] = useState()
  const [toDate, setToDate] = useState()

  useEffect(() => {
    setFromDate()
    setToDate()
  }, [commentModal])

  return (
    <CModal
      alignment='center'
      visible={commentModal.open}
      aria-labelledby='VerticallyCenteredExample'
      onClose={() => {
        setCommentModal({ open: false, type: "", twoField: false })
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id='VerticallyCenteredExample'>{"Фильтр"}</CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>
                {commentModal.type === "start"
                  ? "Начавшиеся с"
                  : "Закончившиеся с"}
              </Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"YYYY-MM-DD"}
                placement={"topRight"}
                onChange={(date) => {
                  setFromDate(date)
                }}
                value={fromDate}
              />
            </div>
            {commentModal.twoField && (
              <div>
                <Typography.Title level={5}>До</Typography.Title>
                <DatePicker
                  style={{ width: "100%" }}
                  format={"YYYY-MM-DD"}
                  placement={"topRight"}
                  onChange={(date) => {
                    setToDate(date)
                  }}
                  value={toDate}
                />
              </div>
            )}
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setCommentModal({ open: false, type: "", twoField: false })
          }}
          style={{ color: "#fff" }}
          color='secondary'
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickSetFilter} style={{ color: "#fff" }}>
          Установить фильтр
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default FilterModal
